<template>
	<div class="fill-height white d-flex flex-column">
		<!-- TOOLBAR -->
		<v-toolbar flat color="primary" dark class="sticky-top flex-grow-0" height="80">
			<v-container class="pa-0">
				<v-row no-gutters align="center">
					<v-col cols="auto" v-for="category in categoryList" :key="category.id">
						<!-- CATEGORIES -->
						<v-menu v-model="category.menu" :close-on-content-click="true" bottom :offset-y="true" attach>
							<template v-slot:activator="{ on, attrs }">
								<v-btn :key="category.id" class="text-none" text v-bind="attrs" v-on="on" height="64">
									{{ category.name }}
									<v-icon right>mdi-chevron-down</v-icon>
								</v-btn>
							</template>
							<v-sheet z-index="10000">
								<v-list dense>
									<v-list-item
										v-for="subCategory in category.children"
										:key="subCategory.id"
										@click="selectCategory(subCategory)"
										style="cursor: pointer;"
									>
										<v-list-item-content>
											<v-list-item-title v-text="subCategory.name"></v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-sheet>
						</v-menu>					
					</v-col>	
					<v-spacer />
					<v-col cols="auto">
						<!-- SEARCH -->	
						<v-btn plain :to="{ name: 'ProductSearch' }">
						<v-icon>mdi-magnify</v-icon>
						</v-btn>							
					</v-col>	
				</v-row>
			</v-container>	
		</v-toolbar>

		<!-- BREADCRUMBS -->
		<v-sheet v-if="isBrowsing && breadcrumbs.length > 0" class="sticky-crumbs flex-grow-0">
			<v-container class="py-2">
				<v-row align="center">
					<v-col cols="auto">
						<v-btn plain icon x-small :to="{ name: 'ProductCatalogHome' }"><v-icon>mdi-home</v-icon></v-btn>
					</v-col>
					<v-col cols="auto" >
						<v-breadcrumbs :items="breadcrumbs" class="pa-0" divider=">">
							<template v-slot:item="{ item }">
								<v-breadcrumbs-item
									:to="item.to"
									:disabled="item.disabled"
								>
									{{ item.text }}
								</v-breadcrumbs-item>
							</template>
						</v-breadcrumbs>
					</v-col>
				</v-row>

			</v-container>	
			
		</v-sheet>

		<div class="flex-grow-1">
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
		
	</div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.sticky-top {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 80px; 
  z-index: 2;
}
.sticky-crumbs {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 160px; 
  z-index: 2;
}
</style>

<script>
import store from "@/store";
import { mapGetters } from "vuex";

export default {
	name: "ProductCatalog",

	data() {
		return {
			isLoading: false,
		};
	},

	beforeRouteUpdate(to, from, next) {
		if (to.name === "ProductCatalogHome") {
			store.dispatch("catalog/resetCategory");
		}
		next();
	},

	beforeRouteLeave(to, from, next) {
		store.dispatch("catalog/resetCategory");
		next();
	},

	mounted() {
		this.isLoading = true;
		store.dispatch("catalog/fetchCatalog")
		.finally(() => {
			this.isLoading = false;
		});
	},

	computed: {

		...mapGetters({
			categoryList: "catalog/categoryList",
			currentCategory: "catalog/currentCategory",
		}),		

		breadcrumbs() {
			let breadcrumbs = [];
			if (this.currentCategory?.path) {
				const path = this.currentCategory.path.map(item => ({
					text: item.name,
					to: { name: 'ProductCategory', params: { id: item.id } },
					disabled: false
				}));
				breadcrumbs = breadcrumbs.concat(path);
				//breadcrumbs[breadcrumbs.length - 1].disabled = true;
			}
			return breadcrumbs;
		},

		isBrowsing() {
			return this.$store.state.catalog.ui.queryType === 'fetch';
		}

	},

	methods: {
		selectCategory(category) {
			this.$router.push({ name: 'ProductCategory', params: { id: category.id } })
		},
	}
};
</script>
